import { cn } from '~/shadcn/lib/utils'

export const TitleLarge = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <p
    className={cn(
      'text-sm lg:text-base leading-[21px] lg:leading-[26px]',
      className
    )}
    {...props}
  />
)
